module.exports = __webpack_public_path__ + "img/cdd7791.jpg";